import { combineReducers } from 'redux';

import filtersReducer from './filtersReducer';
import feedReducer from './feedReducer';

export default combineReducers({
  feed: feedReducer,
  filters: filtersReducer,
});
